import {ValueObject} from '@s-ui/domain'

export class SeoDataValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String} deps.h1
   * @param {String} [deps.staticFallbackH1]
   * @param {Array} deps.head
   * @param {String} deps.head.title
   * @param {Array} deps.head.meta
   * @param {Array} deps.head.link
   * @param {Array} deps.head.scripts
   **/
}
